import React, { useState } from "react";
import useDarkMode from "../../hooks/useDarkMode";
import useThemeColor from "../../hooks/useThemeColor";
import CustomModal from "../../components/CustomComponents/modal/customModal";
import MediaLibrary from "../../components/CustomComponents/mediaLibarary/mediaLibarary";
import "../../components/CustomComponents/ModernGridToolbar/ModernGridToolbar.css";
import "./categoryIcon.css";

const CategoryIconSelection = ({ selectedIcon, setSelectedIcon }) => {
  const [showMediaLibrary, setShowMediaLibrary] = useState(false);
  const [iconSearchTerm, setIconSearchTerm] = useState("");
  const isDarkMode = useDarkMode();
  const themeColor = useThemeColor();

  const handleRemoveIcon = (e) => {
    e?.stopPropagation?.();
    setSelectedIcon(null);
  };

  const handleCloseMediaLibrary = () => {
    setShowMediaLibrary(false);
    setIconSearchTerm("");
  };

  const openMediaLibrary = () => setShowMediaLibrary(true);

  const iconSearchField = (
    <div className={isDarkMode ? "modern-grid-toolbar--dark" : ""}>
      <div
        className="modern-grid-toolbar__search-wrap"
        style={{ flex: "0 0 220px", width: 220, maxWidth: 220, minWidth: 180 }}
      >
        <label className="modern-grid-toolbar__search">
          <i className="fa fa-search modern-grid-toolbar__search-icon" aria-hidden="true" />
          <input
            type="text"
            className="modern-grid-toolbar__search-input"
            value={iconSearchTerm}
            onChange={(e) => setIconSearchTerm(e.target.value)}
            placeholder="Search by name..."
            aria-label="Search by name"
          />
        </label>
      </div>
    </div>
  );

  return (
    <>
      <div
        className={`category-icon-picker${isDarkMode ? " category-icon-picker--dark" : ""}`}
        style={{ "--category-icon-accent": themeColor }}
      >
        <p className="category-icon-picker__label">Category Icon</p>

        <div
          role="button"
          tabIndex={0}
          className={`category-icon-picker__frame${selectedIcon ? " category-icon-picker__frame--filled" : ""}`}
          style={{ borderColor: selectedIcon ? themeColor : undefined }}
          onClick={openMediaLibrary}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              openMediaLibrary();
            }
          }}
          aria-label={selectedIcon ? "Change category icon" : "Upload category icon"}
        >
          {selectedIcon ? (
            <>
              <img
                src={selectedIcon}
                alt="Category icon"
                className="category-icon-picker__img"
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
              <button
                type="button"
                className="category-icon-picker__remove"
                onClick={handleRemoveIcon}
                aria-label="Remove category icon"
                title="Remove icon"
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </>
          ) : (
            <div className="category-icon-picker__empty">
              <div className="category-icon-picker__empty-icon">
                <i className="fa fa-plus" aria-hidden="true" />
              </div>
              <p className="category-icon-picker__empty-title">Add icon</p>
              <p className="category-icon-picker__empty-hint">Click to select</p>
            </div>
          )}
        </div>

        {selectedIcon ? (
          <div className="category-icon-picker__actions">
            <button
              type="button"
              className="category-icon-picker__action category-icon-picker__action--change"
              onClick={openMediaLibrary}
            >
              Change
            </button>
          </div>
        ) : (
          <p className="category-icon-picker__hint">JPG, PNG, or SVG</p>
        )}
      </div>

      <CustomModal
        title="Select an Icon"
        isOpen={showMediaLibrary}
        onClose={handleCloseMediaLibrary}
        showButton={false}
        modalSize="modal-lg"
        isCentered={true}
        compactHeader={true}
        fontSize="18px"
        fontWeight="700"
        headerActions={iconSearchField}
        bodyOverflow="hidden"
        compactHeaderPadding="10px 16px 14px"
        maxHeight="620px"
        themeColor={themeColor}
      >
        <MediaLibrary
          searchTerm={iconSearchTerm}
          onSelectImage={(src) => {
            const iconPath = src.startsWith("/") ? src : `/${src}`;
            setSelectedIcon(iconPath);
            handleCloseMediaLibrary();
          }}
        />
      </CustomModal>
    </>
  );
};

export default CategoryIconSelection;
